import { SortOrder } from 'src/app/core/interface/sort-order';
import { Page } from "src/app/core/models/page";
import { DataScope } from 'src/app/core/models/data-scope';
import { OrderQueryScopeEnum } from 'src/app/core/enums/order-query-scope.enum';

export class DOAbnormalTableHeaderGetRequest extends Page {
  orderQueryScope: OrderQueryScopeEnum;
  userEmail: string;
  facilities: string[] | null;
  consigneeKeys: string[] | null;
  doNos: string[] | null;
  invoiceNos: string[] | null;
  startDate: Date | null;
  endDate: Date | null;
  notified: number | null;
  replied: number | null;
  sortOrder: SortOrder | null;
  roleCodes: string[] | null;
  userType: string | null;
  userDataScopes: DataScope[];

  constructor() {
    super();
    this.orderQueryScope = OrderQueryScopeEnum.personal;
    this.userEmail = "";
    this.facilities = null;
    this.consigneeKeys = null;
    this.doNos = null;
    this.invoiceNos = null;
    this.startDate = null;
    this.endDate = null;
    this.notified = null;
    this.replied = null;
    this.sortOrder = null;
    this.roleCodes = null;
    this.userType = null;
    this.userDataScopes = [];
  }
}
